module.exports = __webpack_public_path__ + "static/media/aluWall1.3b225e0a.jpeg";